export default __webpack_public_path__ + "static/media/tampa-bay-hero-image.0f3601d1.jpg";